// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"f6f58eb8669253eca22a","883":"a7fbbb96903f8b482a87"}[chunkId] + ".js";
};